import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PRESENTATIONS_STATIC_PATH_V2 } from "@/api/staticPaths";
import { canv } from "@/canv/global";
import type { PresentationWidget } from "@/elements/Presentation/Presentation";
import { CloseIcon } from "@/icons";
import { presentationUID } from "@/interface/AppStore";
import { Button } from "@/shared/ui/Button";
import { HStack, VStack } from "@/shared/ui/Stack";
import { selectionManager } from "@/tools/cursorTool";
import styles from "./JoinPresentationModal.module.scss";

const IMG_URL = `${PRESENTATIONS_STATIC_PATH_V2}joinPresentationImage.png`;

export const JoinPresentationModal = NiceModal.create(
    ({ actor, join }: { actor: string; join: () => void }) => {
        const { t } = useTranslation();
        const modal = useModal();
        const UID = useAtomValue(presentationUID);

        const handleClose = () => {
            modal.remove();
        };
        const handleJoin = () => {
            modal.remove();
            const presentation = canv.canvasController.FindByUID(UID) as PresentationWidget;
            if (presentation) {
                presentation.join();
                selectionManager.setSelected([], true);
            }
            join();
        };
        const handleCancel = () => {
            modal.remove();
        };

        useEffect(() => {
            if (!UID) {
                modal.remove();
            }
        }, [UID, modal.remove]);

        return (
            <div className={styles.joinModalWrapper}>
                <VStack className={styles.joinModal}>
                    <HStack className={styles.header}>
                        <button className={styles.closeButton} type="button" onClick={handleClose}>
                            <CloseIcon className={styles.closeIcon} />
                        </button>
                    </HStack>
                    <VStack className={styles.contentWrapper}>
                        <VStack className={styles.content}>
                            <img src={`${canv.host}${IMG_URL}`} alt={""} className={styles.image} />
                            <p className={styles.title}>{t("presentation.starts")}</p>
                            <p className={styles.text}>{t("presentation.invite", { actor })}</p>
                        </VStack>
                        <HStack className={styles.buttonsWrapper}>
                            <Button variant={"primary"} onClick={handleJoin}>
                                {t("presentation.join")}
                            </Button>
                            <Button variant={"tertriary"} onClick={handleCancel}>
                                {t("presentation.skip")}
                            </Button>
                        </HStack>
                    </VStack>
                </VStack>
            </div>
        );
    },
);
